import { trackClientEvent } from 'analytics/analytics'
import type { MessageItem } from 'tripPlanner/components/Chat/MessagesList'

export const CHAT_FEEDBACK_POPUP_USER_MESSAGE_THRESHOLD = 10
export const CHAT_FEEDBACK_POPUP_THROTTLE_MS = 48 * 60 * 60 * 1000
export const CHAT_FEEDBACK_POPUP_STORAGE_KEY = 'chatTripPlanner.feedbackPopup.lastAppearedAt'

const FEEDBACK_EVENT_SUBJECT = 'chat_trip_planner_feedback'

export function getUserMessageCount(messages: Array<MessageItem>): number {
  return messages.filter(message => message.role === 'user').length
}

export function shouldShowChatFeedbackPopup(
  chatId: number | undefined,
  userMessageCount: number,
  lastAppearedAt: number | undefined,
  now: number,
): boolean {
  if (chatId === undefined) {
    return false
  }

  if (userMessageCount < CHAT_FEEDBACK_POPUP_USER_MESSAGE_THRESHOLD) {
    return false
  }

  if (lastAppearedAt !== undefined && now - lastAppearedAt < CHAT_FEEDBACK_POPUP_THROTTLE_MS) {
    return false
  }

  return true
}

export function buildChatFeedbackAction(score: number | undefined, comment: string): string {
  return `${score ?? 'no_score'}_${comment.trim()}`
}

export function trackChatFeedbackPopupAppeared(chatId: number, userMessageCount: number) {
  trackClientEvent({
    subject: FEEDBACK_EVENT_SUBJECT,
    action: `popup_appear_${userMessageCount}`,
    category: String(chatId),
    type: 'nonInteraction',
  })
}

export function trackChatFeedbackSubmitted(chatId: number, score: number | undefined, comment: string) {
  trackClientEvent({
    subject: FEEDBACK_EVENT_SUBJECT,
    action: buildChatFeedbackAction(score, comment),
    category: String(chatId),
    type: 'interaction',
  })
}
